
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/pickup/volkswagen-amarok",
      function () {
        return require("private-next-pages/wheels/pickup/volkswagen-amarok.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/pickup/volkswagen-amarok"])
      });
    }
  